import Marquee from "react-fast-marquee";
import { Sprout } from "lucide-react";

const ITEMS = [
  "Progettazione del verde",
  "Manutenzione",
  "Potatura",
  "Irrigazione a goccia",
  "Piante mediterranee",
  "Giardini che respirano",
];

export const EditorialMarquee = ({ dark = false }) => (
  <div
    className={`overflow-hidden border-y py-5 ${
      dark ? "border-bone/15 bg-forest text-bone" : "border-line bg-bone text-forest"
    }`}
    data-testid="editorial-marquee"
  >
    <Marquee speed={28} gradient={false}>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center gap-10 pr-10">
          <span className="font-serif italic text-2xl md:text-3xl">{t}</span>
          <Sprout className="h-5 w-5 text-terra" strokeWidth={1.5} />
        </span>
      ))}
    </Marquee>
  </div>
);
